//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      dialogShow: false,
      list: [],
      type: 0
    };
  },
  created: function created() {},
  methods: {
    open: function open(data, type) {
      this.list = JSON.parse(data);
      this.type = type;
      this.dialogShow = true;
    }
  }
};